import React from 'react';
import CommonLoader from '@/vdp/Loader';
import Section from '~/constants/vdp/section';

type LoadingProps = {
  error?: Error | null;
  isLoading?: boolean;
};

const dynamicLoader =
  (section: Section, loader?: () => React.JSX.Element) =>
  ({ error, isLoading }: LoadingProps) => {
    if (error) console.error('Error while loading', error);

    const Loader = loader || CommonLoader;

    return isLoading ? (
      <Loader className="section-is-loading" data-section={section} />
    ) : null;
  };

export default dynamicLoader;
